export default "__VITE_ASSET__hMWYCzbo__"